import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UserStore } from '../stores/user.store';
import { isProfileComplete } from '../../shared/utils/profile-photo.utils';

/** Blocks the app until the user has a username and a profile photo. */
export const profileCompleteGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (isProfileComplete(userStore.user())) {
    return true;
  }

  return router.createUrlTree(['/register/photo']);
};
